import { useEffect, useRef } from 'react';
import Lenis from 'lenis';

export const useLenis = () => {
    const lenisRef = useRef(null);
    useEffect(() => {
        const lenis = new Lenis({
            duration: 1.25,
            easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
            smoothWheel: true,
            smoothTouch: false,
            wheelMultiplier: 1,
            touchMultiplier: 1.2,
        });
        lenisRef.current = lenis;
        window.__lenis = lenis;
        let raf;
        const loop = (time) => {
            lenis.raf(time);
            raf = requestAnimationFrame(loop);
        };
        raf = requestAnimationFrame(loop);
        // Expose scroll progress via CSS variable for any consumer
        lenis.on('scroll', ({ scroll, limit }) => {
            const p = limit > 0 ? scroll / limit : 0;
            document.documentElement.style.setProperty('--scroll-progress', String(p));
            window.__scrollProgress = p;
        });
        return () => {
            cancelAnimationFrame(raf);
            lenis.destroy();
            lenisRef.current = null;
            if (window.__lenis === lenis) window.__lenis = null;
        };
    }, []);
    return lenisRef;
};
